import React from 'react';
import { Chip } from '@mui/material';

export type SignatureStatus =
  | 'draft'
  | 'sent'
  | 'viewed'
  | 'completed'
  | 'declined'
  | 'voided'
  | 'expired';

const LABELS: Record<string, string> = {
  draft: 'Signature draft',
  sent: 'Awaiting signature',
  viewed: 'Viewed — unsigned',
  completed: 'Signed',
  declined: 'Declined',
  voided: 'Voided',
  expired: 'Expired',
};

const COLORS: Record<string, 'default' | 'warning' | 'info' | 'success' | 'error'> = {
  draft: 'default',
  sent: 'warning',
  viewed: 'info',
  completed: 'success',
  declined: 'error',
  voided: 'default',
  expired: 'default',
};

export default function SignatureStatusChip({ status }: { status?: string | null }) {
  if (!status) return null;
  return (
    <Chip
      size="small"
      color={COLORS[status] || 'default'}
      label={LABELS[status] || status}
      sx={{ height: 22, fontSize: '0.7rem' }}
    />
  );
}
